import { EanType, FieldNameAndParent } from 'components/inputs/ean/types'

export const FIELD_NAMES_AND_PARENTS: { [key in EanType]: FieldNameAndParent } = {
  [EanType.ELECTRICITY]: {
    parent: 'electricity',
    fieldName: 'ean'
  },
  [EanType.EXCL_NIGHT]: {
    parent: 'electricity',
    fieldName: 'eanExclNight'
  },
  [EanType.GAS]: {
    parent: 'gas',
    fieldName: 'ean'
  }
}
